<template>
  <div>
    <el-card>
      <div slot="header">
        <span>标题</span>
      </div>

      <div class="row-no-full">

        <el-form label-position="top" label-width="80px" :model="item" ref='form' style="flex: 1;" class="row-no-full">

          <div class="col" style="flex: 1;padding-right: 20px;">


            <el-form-item label="邮箱标题" prop="title" required>
              <el-input v-model="item.title" size="small" placeholder="邮箱标题"></el-input>
            </el-form-item>


            <el-form-item label="邮件内容" prop="content" required>
              <el-input v-model="item.content" size="small" placeholder="邮件内容" type='textarea' :autosize="{ minRows: 5}"></el-input>
            </el-form-item>

            <el-form-item label="发送时间">


              <div class="row-no-full">

                <el-radio-group v-model="item.send_time" style="margin-right: 20px;">
                  <el-radio-button :label="1">延迟</el-radio-button>
                  <el-radio-button :label="2">定时</el-radio-button>
                </el-radio-group>

                <div v-if="item.send_time==1">
                  <el-input v-model="item.send_time_value" style="flex: 1;" placeholder="延迟(秒)"></el-input>
                </div>

                <div v-else>

                  <!-- <el-date-picker v-model="item.send_time_value" type="date" placeholder="选择日期">
                  </el-date-picker> -->


                  <el-date-picker v-model="item.send_time_value" type="datetime" placeholder="选择日期时间">
                  </el-date-picker>

                </div>



              </div>

            </el-form-item>


            <el-form-item label="优先级">

              <el-radio-group v-model="item.order">

                <el-radio-button label="low">低</el-radio-button>
                <el-radio-button label="default">中</el-radio-button>
                <el-radio-button label="high">高</el-radio-button>
              </el-radio-group>

            </el-form-item>




            <el-form-item>
              <el-button v-if="item.send_type==1" type="primary" size="small" @click='submit()'>提交</el-button>
              <el-button v-if="item.send_type==2" type="primary" size="small" @click='submitAll()'>提交</el-button>
            </el-form-item>


          </div>


          <div class="col" style="flex: 1;padding-left: 20px;">

            <el-form-item label="发送类型" prop="username">
              <el-radio-group v-model="item.send_type">
                <el-radio-button label="1">测试</el-radio-button>
                <el-radio-button label="2">正式</el-radio-button>
              </el-radio-group>
            </el-form-item>


            <template v-if="item.send_type==1">

              <el-form-item label="测试名单" prop="username">

                <el-input v-model="item.email_test" size="small" placeholder="测试名单" type='textarea' :autosize="{ minRows: 5}"></el-input>

              </el-form-item>


            </template>


            <template v-if="item.send_type==2">

              <div class="col">
                <div class="el-form-item__label">上传Excel表格</div>

                <!-- <el-button type="primary"></el-button> -->
                <upload @success='uploadExcel'>
                  <el-button type='success'>上传</el-button>
                </upload>


                <div>

                  <el-table :data="item.email_list" border style="max-width: 100%;max-height: 500px;overflow-y: scroll;">
                    <el-table-column label="序号">

                      <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                      </template>

                    </el-table-column>

                    <el-table-column label="邮箱">

                      <template slot-scope="scope">
                        <span>{{scope.row}}</span>
                      </template>

                    </el-table-column>




                  </el-table>


                </div>



              </div>


            </template>



          </div>

        </el-form>

      </div>


    </el-card>


    <el-dialog

      :visible.sync="showAlert"
      width="30%"
      :show-close='showClose'

      :before-close="handleClose">
      <div>

        <div style="text-align: center;margin-bottom: 20px;">发送进度</div>

        <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>

      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>



  </div>
</template>

<script>
  import Upload from '../common/Upload.vue'

  export default {
    name: "BatchEmail",
    data() {
      return {
        item: {
          username: '',
          send_time: 1,
          order: 'low',
          send_type: 1,
          send_time_value: '',
          content: '',
          title: '',
          //测试名单
          email_test: '',
          //正式名单
          email_list: []
        },
        //每批的数量
        maxSize:10,
        //当前批数
        page:1,

        showAlert:false,
        showClose:false




      }
    },
    methods: {

      submit() {


        this.$refs['form'].validate((valid) => {
          if (valid) {

            this.msgBoxAjax('提示', '确定提交吗？', '/admin/email/sendEmail', this.item).then((re) => {

            })


          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
      submitAll(){

          if(!this.currentEmail.length>0) return false;

          this.$refs['form'].validate((valid) => {
            if (valid) {

              // this.msgBoxAjax('提示', '确定提交吗？', '/admin/email/sendEmail', this.item).then((re) => {

              // })

              this.messageCommon('提示','确定提交所有邮件吗?','info').then(()=>{

                this.showAlert=true;

                this.sendEmail();
              })



            } else {
              console.log('error submit!!');
              return false;
            }
          });


      },

      sendEmail(){

        if(this.currentEmail<=0){

         // this.showClose=true;
         
         this.showAlert=false;

         this.page=1;

         return;
        }



        let temp=this.cloneObj(this.item);

        temp.email_list=null;

        temp.current_email=this.currentEmail;

        this.httpPost({
          url:"/admin/email/sendEmail",
          data:temp
        }).then(()=>{


          this.page++;

          this.sendEmail();


        })


      },

      uploadExcel(file) {

        // console.log(file);

        this.httpPost({
          url: "/admin/email/readExcel",
          data: {
            file: file
          },
          loading: true
        }).then((re) => {

          // console.log(re);

          this.item.email_list = re.data;

        })





      },
      handleClose(done){

        if(this.showClose) done();

      }


    },
    created() {

    },
    computed: {

      currentEmail(){



        if(this.item.email_list.length<=0) return [];


        let offset=(this.page-1)*this.maxSize;

        return this.item.email_list.slice(offset,offset+this.maxSize);



      },
      /**
       * 总页数
       */
      totalPage(){

        if(this.item.email_list.length<=0) return 1;

        return Math.ceil(this.item.email_list.length / this.maxSize);
      },
      percentage(){


        return (this.page-1)/this.totalPage*100;
      }

    },
    components: {

      Upload

    },
    watch: {

      'item.send_time': function(value) {

        this.item.send_time_value = '';

      }

    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/batch/BatchEmail.vue